import { useMediaQuery, useTheme } from '@mui/material';
import i18next from 'i18next';
import React from 'react';
import { Trans } from 'react-i18next';

import { Icon } from '../Icon';
import * as Styled from './ListWithIcons.styles';

const ListOfIcons = ({ isIndividualElements, title, data }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const renderItem = (item, index) => (
    <Styled.ItemWrapper
      key={item.text || item}
      isIndividualElements={isIndividualElements}
    >
      <Styled.ItemContainer isIndividualElements={isIndividualElements}>
        <Styled.CheckIconWrapper isIndividualElements={isIndividualElements}>
          <Icon
            variant="solarCheckCircle"
            color={theme.palette.color.fg.tetriary}
            size={isMobile ? 'md' : 'lg'}
          />
        </Styled.CheckIconWrapper>
        <Styled.TextWrapper isIndividualElements={isIndividualElements}>
          {item.title && (
            <Styled.ItemTitle as="h4">{item.title}</Styled.ItemTitle>
          )}
          <Styled.Text variant="body16">
            <Trans
              i18nKey={item.text || item}
              components={{
                b: <b />,
                br: <div style={{ margin: '8px' }} />,
                email: (
                  <a
                    href={`mailto:legal@hudd.${i18next.language === 'sv' ? 'se' : i18next.language}`}
                    rel="noreferrer"
                  />
                ),
                supportEmail: (
                  <a
                    href={`mailto:support@hudd.${i18next.language === 'sv' ? 'se' : i18next.language}`}
                    rel="noreferrer"
                  />
                ),
              }}
            />
          </Styled.Text>
          {item.list && (
            <Styled.ULList>
              {item.list.map((_item, index) => (
                <Styled.ULListItem key={index}>{_item}</Styled.ULListItem>
              ))}
            </Styled.ULList>
          )}
          {item.textUnderList && (
            <Styled.Text hasMarginTop>{item.textUnderList}</Styled.Text>
          )}
        </Styled.TextWrapper>
      </Styled.ItemContainer>
      {index !== data.length - 1 && !isIndividualElements && <Styled.Divider />}
    </Styled.ItemWrapper>
  );
  return (
    <Styled.Wrapper>
      <Styled.Title as="h2">{title}</Styled.Title>
      <Styled.ItemsWrapper isIndividualElements={isIndividualElements}>
        {data?.map(renderItem)}
      </Styled.ItemsWrapper>
    </Styled.Wrapper>
  );
};

export default ListOfIcons;
